import { InputText } from "primereact/inputtext";

type TitleField = {
  value: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
};

const TitleField: React.FC<TitleField> = (props) => {
  return (
    <div className="device-setting-group">
      <b>Titel</b>
      <p>
        Geben Sie einen sprechenden Titel für das zu erstellende Szenario an
      </p>
      <InputText id="title" value={props.value} onChange={props.onChange} />
    </div>
  );
};

export default TitleField;
